/** AB TOMIC — interactions légères, sans dépendance. */

(() => {
  'use strict';

  /* ---------- Apparition douce des sections ---------- */
  const reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && document.body.classList.contains('anime')) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -10% 0px' }
    );
    reveals.forEach((el) => observer.observe(el));
  } else {
    reveals.forEach((el) => el.classList.add('is-visible'));
  }

  /* ---------- Galerie : vignettes synchronisées avec le défilement ---------- */
  document.querySelectorAll('[data-galerie]').forEach((galerie) => {
    const piste = galerie.querySelector('[data-galerie-piste]');
    const vignettes = [...galerie.querySelectorAll('[data-galerie-vignette]')];
    const prec = galerie.querySelector('[data-galerie-prec]');
    const suiv = galerie.querySelector('[data-galerie-suiv]');
    const position = galerie.querySelector('[data-galerie-position]');
    const total = piste ? piste.children.length : 0;
    if (!piste || total < 2) return;

    const activer = (index) => {
      vignettes.forEach((v, i) => v.setAttribute('aria-current', String(i === index)));
      if (position) position.textContent = index + 1;
      if (prec) prec.disabled = index <= 0;
      if (suiv) suiv.disabled = index >= total - 1;
    };
    const indexActuel = () => Math.round(piste.scrollLeft / piste.clientWidth);
    const aller = (index) => {
      const cible = Math.max(0, Math.min(total - 1, index));
      piste.scrollTo({ left: piste.clientWidth * cible, behavior: 'smooth' });
      activer(cible);
    };
    prec?.addEventListener('click', () => aller(indexActuel() - 1));
    suiv?.addEventListener('click', () => aller(indexActuel() + 1));
    activer(0);

    vignettes.forEach((vignette, index) => {
      vignette.addEventListener('click', (event) => {
        event.preventDefault();
        aller(index);
      });
    });

    let attente;
    piste.addEventListener('scroll', () => {
      clearTimeout(attente);
      attente = setTimeout(() => activer(indexActuel()), 80);
    });
  });

  /* ---------- Menu mobile ---------- */
  document.querySelectorAll('[data-menu]').forEach((menu) => {
    const fermer = () => menu.removeAttribute('open');
    menu.querySelector('[data-menu-fermer]')?.addEventListener('click', fermer);
    /* Clic sur le fond sombre (en dehors du panneau) */
    menu.addEventListener('click', (event) => {
      if (event.target === menu) fermer();
    });
    menu.querySelectorAll('a').forEach((lien) => lien.addEventListener('click', fermer));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && menu.open) {
        fermer();
        menu.querySelector('summary')?.focus();
      }
    });
    menu.addEventListener('toggle', () => {
      document.documentElement.style.overflow = menu.open ? 'hidden' : '';
    });
  });

  /* ---------- Boutons « Commander » : ouvrent directement le formulaire EasySell ---------- */
  document.addEventListener('click', (event) => {
    const lien = event.target.closest('[data-commander]');
    /* Hors page produit, le lien mène simplement à la page produit */
    if (!lien || !document.body.classList.contains('template-product')) return;
    const boutonEasySell = document.querySelector('#commander .es-popup-button, .es-popup-button-product');
    if (boutonEasySell) {
      event.preventDefault();
      boutonEasySell.click();
    }
  });

  /* ---------- Formulaire minimal : empêche les doubles envois ---------- */
  document.querySelectorAll('#commander form.commande').forEach((form) => {
    form.addEventListener('submit', (event) => {
      if (form.dataset.envoi === 'true') {
        event.preventDefault();
        return;
      }
      form.dataset.envoi = 'true';
    });
    window.addEventListener('pageshow', () => {
      form.dataset.envoi = 'false';
    });
  });

  /* ---------- Barre « Commander » qui suit le défilement ----------
     Masquée tant qu'un autre bouton « Commander » est à l'écran : bouton du
     hero, formulaire de la page produit, bande du pied de page. */
  const barre = document.querySelector('[data-barre-commande]');
  if (barre && 'IntersectionObserver' in window) {
    const zones = ['.hero__actions', '#commander', '.pied__appel']
      .map((selecteur) => document.querySelector(selecteur))
      .filter(Boolean);
    const visibles = new Set(zones);
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) visibles.add(entry.target);
        else visibles.delete(entry.target);
      });
      barre.classList.toggle('is-masquee', visibles.size > 0);
    });
    zones.forEach((zone) => observer.observe(zone));
  }
})();
